/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Integration_Connect_Not_AuthenticatedInputs */

const en_integration_connect_not_authenticated = /** @type {(inputs: Integration_Connect_Not_AuthenticatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign in to Listening, then connect ${i?.provider} again.`)
};

const es_integration_connect_not_authenticated = /** @type {(inputs: Integration_Connect_Not_AuthenticatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inicia sesión en Listening y vuelve a conectar ${i?.provider}.`)
};

/**
* | output |
* | --- |
* | "Sign in to Listening, then connect {provider} again." |
*
* @param {Integration_Connect_Not_AuthenticatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_connect_not_authenticated = /** @type {((inputs: Integration_Connect_Not_AuthenticatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_Connect_Not_AuthenticatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_connect_not_authenticated(inputs)
	return en_integration_connect_not_authenticated(inputs)
});